module.exports = __webpack_public_path__ + "img/transaction.0e9bc87b.jpg";